import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import React from "react";

import "../../src/assets/css/modalAction.css";

const ModalInterface = (props) => {
  return (
    <Modal
      centered
      size={props.bsSize}
      onHide={!props.display}
      toggle={props.closeEvent}
      isOpen={props.display}
      className={props.className}
    >
      {props.title && (
        <div className="header-modal modal-details p-3">
          <h4 className="mb-0">{props.title}</h4>
        </div>
      )}
      <ModalBody className="body-modal modal-details">
        <>{props.content}</>
      </ModalBody>
      {props?.footer && (
        <ModalFooter className="justify-content-center">
          <Button variant="danger" onClick={props.closeEvent}>
            Close
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default ModalInterface;
